
export const LOGO_URL_DARK_MODE = "https://housebuenosaires.com/wp-content/uploads/2023/05/logo-hba-eventos-png-corporativos-web.png"; 
export const LOGO_URL_LIGHT_MODE = "https://housebuenosaires.com/wp-content/uploads/2024/08/logo-firma-mail-hba-eventos-2024.png"; 
export const LOGO_HBA_ICON_URL = "https://housebuenosaires.com/wp-content/uploads/2023/05/logo-hba-eventos-png-corporativos-web.png"; // Icono para la pista, usualmente claro/simple


export const DEFAULT_VENUE_WIDTH = 23; // meters - Actualizado
export const DEFAULT_VENUE_LENGTH = 18; // meters - Actualizado
export const DEFAULT_GUESTS = 100;
export const DEFAULT_SEATS_PER_TABLE = "8"; // Default, pero el slider ahora va de 4 a 12

// Standard Table dimensions (meters)
export const TABLE_ROUND_SEATS_4_DIAMETER = 1.0;
export const TABLE_ROUND_SEATS_6_DIAMETER = 1.2;
export const TABLE_ROUND_SEATS_8_DIAMETER = 1.5;
export const TABLE_ROUND_SEATS_10_DIAMETER = 1.8;
export const TABLE_ROUND_SEATS_12_DIAMETER = 2.1; 

export const TABLE_RECT_SEATS_4_WIDTH = 1.2; 
export const TABLE_RECT_SEATS_4_HEIGHT = 0.75; 
export const TABLE_RECT_SEATS_6_WIDTH = 1.8; 
export const TABLE_RECT_SEATS_6_HEIGHT = 0.8; 
export const TABLE_RECT_SEATS_8_WIDTH = 2.4; 
export const TABLE_RECT_SEATS_8_HEIGHT = 0.9;
export const TABLE_RECT_SEATS_10_WIDTH = 2.4; 
export const TABLE_RECT_SEATS_10_HEIGHT = 1.0; 
export const TABLE_RECT_SEATS_12_WIDTH = 3.0; 
export const TABLE_RECT_SEATS_12_HEIGHT = 1.0;

export const TABLE_SQUARE_SEATS_4_SIDE = 1.0; 
export const TABLE_SQUARE_SEATS_8_SIDE = 1.5; 
export const TABLE_SQUARE_SEATS_12_SIDE = 1.8; 

// Living Area dimensions (meters) - Represented as rectangular areas - REDUCED BY 17% (multiplied by 0.83)
export const TABLE_LIVING_SEATS_4_WIDTH = 2.5 * 0.83;    // 2.075
export const TABLE_LIVING_SEATS_4_HEIGHT = 1.8 * 0.83;   // 1.494
export const TABLE_LIVING_SEATS_6_WIDTH = 3.0 * 0.83;    // 2.49
export const TABLE_LIVING_SEATS_6_HEIGHT = 2.0 * 0.83;   // 1.66
export const TABLE_LIVING_SEATS_8_WIDTH = 3.5 * 0.83;    // 2.905
export const TABLE_LIVING_SEATS_8_HEIGHT = 2.5 * 0.83;   // 2.075
export const TABLE_LIVING_SEATS_10_WIDTH = 4.0 * 0.83;   // 3.32
export const TABLE_LIVING_SEATS_10_HEIGHT = 3.0 * 0.83;  // 2.49
export const TABLE_LIVING_SEATS_12_WIDTH = 4.5 * 0.83;   // 3.735
export const TABLE_LIVING_SEATS_12_HEIGHT = 3.5 * 0.83;  // 2.905


// Main Table default dimensions
export const DEFAULT_MAIN_TABLE_WIDTH = 3.0;
export const DEFAULT_MAIN_TABLE_LENGTH = 1.0;
export const DEFAULT_MAIN_TABLE_SEATS = 4; 

// Custom Element default dimensions
export const DEFAULT_CUSTOM_ELEMENT_WIDTH = 2.0;
export const DEFAULT_CUSTOM_ELEMENT_HEIGHT = 1.0;


export const CHAIR_CLEARANCE = 0.75; 
export const MIN_WALKWAY_SPACE = 0.6; 

// Definición de dimensiones de pista de baile por cantidad de invitados
export const DANCE_FLOOR_DIMENSIONS_BY_GUESTS: { minGuests: number; maxGuests: number; width: number; height: number; }[] = [
    { minGuests: 0, maxGuests: 50, width: 4, height: 5 },      
    { minGuests: 51, maxGuests: 80, width: 5, height: 6 },     
    { minGuests: 81, maxGuests: 150, width: 7.2, height: 4.8 }, 
    { minGuests: 151, maxGuests: 200, width: 7, height: 7 },   
    { minGuests: 201, maxGuests: 250, width: 8, height: 8 },   
    { minGuests: 251, maxGuests: 300, width: 9, height: 8 },   
    { minGuests: 301, maxGuests: 400, width: 10, height: 10 }, 
    { minGuests: 401, maxGuests: 500, width: 12, height: 10 }, 
    { minGuests: 501, maxGuests: Infinity, width: 12, height: 10 } 
];


export const DANCE_FLOOR_AREA_PER_DANCER = 0.75; 
export const PERCENT_GUESTS_DANCING = 0.4; 


export const PIXEL_SCALE_DEFAULT = 20; 

export const HELP_MODAL_CONTENT = [
  {
    title: "1. Define tu Evento:",
    text: "Ingresa las medidas del salón (ancho y largo) y la cantidad total de invitados. La barra superior te mostrará en tiempo real si el espacio es suficiente."
  },
  {
    title: "2. Elige tu Estilo:",
    text: "Selecciona si prefieres mesas Redondas, Cuadradas, Rectangulares o Livings. Indica cuántas personas se sentarán en cada una y si deseas incluir Pista de Baile o Mesa Principal."
  },
  {
    title: "3. Genera el Plano:",
    text: "Presiona el botón 'Generar Plano'. El sistema acomodará automáticamente todas las mesas de forma simétrica y ordenada, aprovechando al máximo el espacio disponible."
  },
  {
    title: "4. Personaliza a tu Gusto:",
    text: "Puedes arrastrar cualquier mesa o la pista de baile para moverla. El sistema es inteligente: si mueves algo, los objetos cercanos se acomodarán suavemente para abrir paso, evitando superposiciones."
  },
  {
    title: "5. Agrega Detalles Extra:",
    text: "¿Hay columnas, una barra de tragos o una cabina de DJ? Agrégalos desde la sección 'Elementos Personalizados' para que tu plano sea fiel a la realidad."
  },
  {
    title: "6. Asigna los Lugares:",
    text: "Toca cualquier mesa y selecciona el icono de 'Usuarios' (👥) para escribir los nombres de los invitados que se sentarán allí. ¡Ideal para organizar el seating plan!"
  },
  {
    title: "7. Ajuste Fino:",
    text: "Si necesitas más espacio, puedes acercar las mesas manualmente. Las líneas punteadas muestran la zona ideal de circulación, pero el sistema te permitirá juntarlas más si es necesario (hasta entrelazar las sillas)."
  },
  {
    title: "8. Exporta tu Trabajo:",
    text: "Al finalizar, presiona el botón 'PDF' arriba a la derecha. Obtendrás un documento profesional con el plano visual, las estadísticas y la lista de invitados detallada."
  }
];
